import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
  size?: 'md';
  className?: string;
  [restProps: string]: any;
}

const Article: FC<IProps> = ({ children, size, className, ...restProps }) => (
  <article
    className={classNames(css.article, { [css[`article_size_${size}`]]: size }, className)}
    {...restProps}
  >
    {children}
  </article>
);

export default Article;
